"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTargetingOperator = exports.UserTargetingValueType = exports.PublisherCampaignEventCostWindow = exports.EventTypeCosts = exports.EventNameCosts = exports.PublisherCampaignCpiWindow = exports.MmpCampaignStatus = exports.ActivatedOfferDoc = exports.ActivatedOffer = exports.PartnerAppPayoutInfo = exports.BatchPlaytimeConfig = exports.OfferActivateTask = exports.SurveyTask = exports.PurchaseTask = exports.MMPTask = exports.GenericTask = exports.SurveyTaskConfig = exports.OfferActivateTaskConfig = exports.PurchaseTaskConfig = exports.MMPTaskConfig = exports.GenericTaskConfig = exports.MMPTaskConfigData = exports.BatchTaskConfig = exports.ResourceRewards = exports.FTimestampFunc = exports.FTimestamp = exports.DocId = exports.OFFER_TYPE = exports.OfferTypeEnum = exports.OfferType = exports.OfferTaskRewardReasons = exports.TaskTypeEnum = exports.TaskType = exports.GameCategoryEnum = exports.GameCategory = exports.UserEventTypesEnum = exports.UserEventTypes = exports.VerificationMethodEnum = exports.VerificationMethod = exports.MmpCampaignStatusTypeEnum = exports.MmpCampaignStatusType = exports.GamePlatformEnum = exports.GamePlatform = exports.FIREBASE_COLLECTIONS = exports.MMPProviderEnum = exports.MMPProvider = exports.CurrencyTypeEnum = exports.CurrencyType = exports.AppTypeEnum = exports.AppType = void 0;
exports.DeviceInfo = exports.OfferwallAdditionalParams = exports.UserConnectedEmail = exports.GrantNotification = exports.PBRUserDoc = exports.DailyStreak = exports.UserCoreDoc = exports.UserCore = exports.EventVerification = exports.UserEventTypeMapping = exports.VerificationStatusEnum = exports.VerificationStatus = exports.UserStatusEnum = exports.UserStatus = exports.RewardDoc = exports.Reward = exports.RewardsObject = exports.MmpClickIds = exports.ExpUserDoc = exports.ExpUser = exports.UserBalanceFE = exports.PublisherCampaignFE = exports.OrderData = exports.TremendousOrderData = exports.TremendousOrder = exports.TremendousReward = exports.TremendousDelivery = exports.TremendousRecipient = exports.TremendousValue = exports.TremendousPayment = exports.OrderStart = exports.ActivateOfferBody = exports.ActivateOfferStart = exports.ClickUrlResponse = exports.SurveyInstance = exports.SurveyResponse = exports.SurveyQuestionSet = exports.SurveyQuestion = exports.SurveyAnswerOption = exports.SurveyResponseBody = exports.OffersFilteredByCategoryQuery = exports.GetExpTransactionsQuery = exports.Publisher = exports.AdminEventVerificationDTO = exports.PublisherCampaign = exports.CampaignCostWindow = exports.PartnerAppCampaignSettings = exports.UserTargeting = exports.UserTargetingCondition = exports.UserTargetingOperatorEnum = void 0;
exports.SystemConfig = exports.PartnerAppFE = exports.PartnerApp = exports.PartnerAppOfferSettings = exports.PartnerAppFeatureConfig = exports.PartnerAppStylingConfig = exports.AlternativeNameDiffsRequestSchema = exports.AlternativeNameDiffsSchema = exports.PLAYBACK_GAME_CATEGORIES_MAPPING = exports.UserTargetingConfig = exports.NamedFunction = exports.UnclaimedReward = exports.UserStats = exports.PiggyBankChestConfig = exports.NativeAppDetails = exports.ABTestGroupValues = exports.ABTestDynamicProfitabilityScalingGroupEnum = exports.ABTestDynamicProfitabilityScalingGroup = exports.ABTestDailyStreakGroupEnum = exports.ABTestDailyStreakGroup = exports.AB_UNLOCK_EARNED_PIGGY = exports.ABTestMinimumRedemptionGroupEnum = exports.AB_TEST_MINIMUM_REDEMPTION_GROUP = exports.BigVerticalOfferListGroupEnum = exports.BIG_VERTICAL_OFFER_LIST_TEST_GROUP = exports.ABUnlockAllOffersGroupEnum = exports.AB_UNLOCK_ALL_OFFERS_GROUP = exports.ABTestingNamesEnum = exports.AB_TESTING_NAMES = exports.UserRatingFeedbackBody = exports.UserFeedbackUpdateTypeEnum = exports.UserFeedbackUpdateType = exports.DailyStreakConfig = exports.AdminLog = exports.AdminLogTypeEnum = exports.AdminLogType = exports.UserStatusChangeDetails = exports.UserStatusAdminReasonEnum = exports.UserStatusAdminReason = exports.FrozenAccountReasonsEnum = exports.FrozenAccountReasons = exports.CombinedUser = exports.DeviceDoc = exports.Device = void 0;
const zod_1 = require("zod");
const countryCode_1 = require("./countryCode");
var AppType;
(function (AppType) {
    AppType["PLAYBACK_REWARDS"] = "PLAYBACK_REWARDS";
    AppType["PLAYTEST_REWARDS"] = "PLAYTEST_REWARDS";
    AppType["PLAYBITE"] = "PLAYBITE";
    AppType["OFFERWALL"] = "OFFERWALL";
})(AppType || (exports.AppType = AppType = {}));
exports.AppTypeEnum = zod_1.z.nativeEnum(AppType);
var CurrencyType;
(function (CurrencyType) {
    CurrencyType["COINS"] = "COINS";
    CurrencyType["PIGGY_BANKS"] = "PIGGY_BANKS";
})(CurrencyType || (exports.CurrencyType = CurrencyType = {}));
exports.CurrencyTypeEnum = zod_1.z.nativeEnum(CurrencyType);
var MMPProvider;
(function (MMPProvider) {
    MMPProvider["NONE"] = "NONE";
    MMPProvider["APPSFLYER"] = "APPSFLYER";
    MMPProvider["BESITOS"] = "BESITOS";
    MMPProvider["MOTIVE"] = "MOTIVE";
    MMPProvider["SINGULAR"] = "SINGULAR";
    MMPProvider["ADJUST"] = "ADJUST";
    MMPProvider["BITLAB"] = "BITLAB";
    MMPProvider["HANG_MY_ADS"] = "HANG_MY_ADS";
    MMPProvider["AD_ACTION"] = "AD_ACTION";
    MMPProvider["FEEDMOB"] = "FEEDMOB";
    MMPProvider["TYR_REWARDS"] = "TYR_REWARDS";
    MMPProvider["APP_SAMURAI"] = "APP_SAMURAI";
    MMPProvider["TOROX"] = "TOROX";
    MMPProvider["PERFORM_CB"] = "PERFORM_CB";
})(MMPProvider || (exports.MMPProvider = MMPProvider = {}));
exports.MMPProviderEnum = zod_1.z.nativeEnum(MMPProvider);
exports.FIREBASE_COLLECTIONS = {
    GIFT_CARDS: 'GiftCards',
    USER: 'User',
    DELETED_DOCUMENT: 'DeletedDocument',
    GIFT_CARD_ORDERS: 'GiftCardOrders',
    WHITELIST: 'Whitelist',
    OFFER: 'Offers',
    FEATURED_GAME_OFFER: 'FeaturedGameOffers',
    USER_OFFERS: 'UserOffers',
    OFFER_LIST_SUB_COLLECTION: 'OfferList',
    APP_METADATA: 'AppMetadata',
    UNIFIED_APP_MAPPINGS: 'UnifiedAppMappings',
    RECEIPTS: 'Receipts',
    REWARDS: 'Rewards',
    USER_EMAILS: 'UserEmails',
    BLOCKS: 'Blocks',
    SINGULAR_POSTBACKS: 'SingularPostbacks',
    APPSFLYER_UA_POSTBACKS: 'AppsflyerUAPostback',
    APPSFLYER_POSTBACKS: 'AppsflyerPostbacks',
    ADJUST_POSTBACKS: 'AdjustPostbacks',
    APPLE_POSTBACKS: 'ApplePostbacks',
    CAKE_POSTBACKS: 'CakePostbacks',
    BITLAB_POSTBACKS: 'BitlabPostbacks',
    HANG_MY_ADS_POSTBACKS: 'HangMyAdsPostbacks',
    AD_ACTION_POSTBACKS: 'AdgemPostbacks',
    APP_SAMURAI_POSTBACKS: 'AppSamuraiPostbacks',
    TOROX_POSTBACKS: 'ToroxPostbacks',
    FEEDMOB_POSTBACKS: 'FeedmobPostbacks',
    TYR_POSTBACKS: 'TyrPostbacks',
    ACTIVATED_USER_OFFERS: 'ActivatedUserOffers',
    PROMOTION_OFFERS: 'PromotionOffers',
    GAMING_HISTORY: 'GamingHistory',
    EXCHANGE_RATES: 'ExchangeRates',
    USERS_CONNECTED_EMAILS: 'UserConnectedEmails',
    MMP_CLICK_IDS: 'MmpClickIds',
    FAILED_REWARD: 'FailedReward',
    PARSED_EMAILS: 'ParsedEmails',
    REFERRAL_OFFERS: 'ReferralOffers',
    REFERRAL_TRACKED: 'ReferralTracked',
    REFERRAL_REWARDS: 'ReferralRewards',
    REFERRAL_USERS_IDS: 'ReferralUsersIds',
    SIGNUP_ATTRIBUTION: 'SignupAttribution',
    RECEIPT_LOOKUP: 'ReceiptLookup',
    JOBS: 'Jobs',
    PROD_USER_CLONE: 'ProdUserClone',
    DEVICES: 'Devices',
    STRIPE_IDENTITIES: 'StripeIdentities',
    QUESTS: 'Quests',
    USER_QUESTS: 'UserQuests',
    SETTINGS: 'Settings',
    NATIVE_APP_BOOT_TRACKING: 'NativeAppBootTracking',
    SEGMENT_CONFIG: 'SegmentConfig',
    PLAYTIME_REWARDS_CONFIGS: 'PlaytimeRewardsConfigs',
    UNVERIFIED_APP_USAGE: 'UnverifiedAppUsage',
    VERIFIED_APP_USAGE: 'VerifiedAppUsage',
    PARTNER_POSTBACK: 'PartnerPostback',
    PARTNER_POSTBACK_RESULTS: 'PartnerPostbackResults',
    BASE_EVENT_VERIFICATIONS: 'BaseEventVerifications',
    PUBLISHERS: 'Publishers',
    PUBLISHER_CAMPAIGNS: 'PublisherCampaigns',
    CAMPAIGN_OFFERS: 'CampaignOffers',
    CAMPAIGN_PERFORMANCE: 'CampaignPerformance',
    SYSTEM_CONFIGS: 'SystemConfigs',
    EVENT_VERIFICATIONS: 'EventVerifications',
    POSTBACK_RULES: 'PostbackRules',
    USER_EVENT_TYPE_MAPPINGS: 'UserEventTypeMappings',
    EXP_USER: 'ExpUser',
    EXP_SURVEYS: 'ExpSurveys',
    ADMIN_LOG: 'AdminLog',
    PLAYBITE_USERS: 'PlaybiteUsers',
    OFFERWALL_USERS: 'OfferwallUsers',
    REFERRAL_USER_CONFIGS: 'ReferralUserConfigs',
};
var GamePlatform;
(function (GamePlatform) {
    GamePlatform["Android"] = "Android";
    GamePlatform["iOS"] = "iOS";
})(GamePlatform || (exports.GamePlatform = GamePlatform = {}));
exports.GamePlatformEnum = zod_1.z.nativeEnum(GamePlatform);
var MmpCampaignStatusType;
(function (MmpCampaignStatusType) {
    MmpCampaignStatusType["ACTIVE"] = "ACTIVE";
    MmpCampaignStatusType["INACTIVE"] = "INACTIVE";
    MmpCampaignStatusType["ERROR"] = "ERROR";
    MmpCampaignStatusType["PAUSED"] = "PAUSED";
})(MmpCampaignStatusType || (exports.MmpCampaignStatusType = MmpCampaignStatusType = {}));
exports.MmpCampaignStatusTypeEnum = zod_1.z.nativeEnum(MmpCampaignStatusType);
var VerificationMethod;
(function (VerificationMethod) {
    VerificationMethod["MMP"] = "MMP";
    VerificationMethod["PLAYBACK_ADMIN"] = "PLAYBACK_ADMIN";
})(VerificationMethod || (exports.VerificationMethod = VerificationMethod = {}));
exports.VerificationMethodEnum = zod_1.z.nativeEnum(VerificationMethod);
var UserEventTypes;
(function (UserEventTypes) {
    UserEventTypes["INSTALL"] = "INSTALL";
    UserEventTypes["UNKNOWN"] = "UNKNOWN";
    UserEventTypes["PURCHASE"] = "PURCHASE";
})(UserEventTypes || (exports.UserEventTypes = UserEventTypes = {}));
exports.UserEventTypesEnum = zod_1.z.nativeEnum(UserEventTypes);
var GameCategory;
(function (GameCategory) {
    GameCategory["Action"] = "Action";
    GameCategory["Adventure"] = "Adventure";
    GameCategory["Casual"] = "Casual";
    GameCategory["Board"] = "Board";
    GameCategory["Card"] = "Card";
    GameCategory["Casino"] = "Casino";
    GameCategory["Educational"] = "Educational";
    GameCategory["Family"] = "Family";
    GameCategory["Music"] = "Music";
    GameCategory["Puzzle"] = "Puzzle";
    GameCategory["Racing"] = "Racing";
    GameCategory["RolePlaying"] = "Role Playing";
    GameCategory["Simulation"] = "Simulation";
    GameCategory["Sports"] = "Sports";
    GameCategory["Strategy"] = "Strategy";
    GameCategory["Trivia"] = "Trivia";
    GameCategory["Word"] = "Word";
})(GameCategory || (exports.GameCategory = GameCategory = {}));
exports.GameCategoryEnum = zod_1.z.nativeEnum(GameCategory);
var TaskType;
(function (TaskType) {
    TaskType["MMP_EVENT"] = "MMP_EVENT";
    TaskType["PLAYTIME"] = "PLAYTIME";
    TaskType["PURCHASE"] = "PURCHASE";
    TaskType["PURCHASE_AMOUNT"] = "PURCHASE_AMOUNT";
    TaskType["SURVEY"] = "SURVEY";
    TaskType["OFFER_ACTIVATION"] = "OFFER_ACTIVATION";
})(TaskType || (exports.TaskType = TaskType = {}));
exports.TaskTypeEnum = zod_1.z.nativeEnum(TaskType);
exports.OfferTaskRewardReasons = [
    TaskType.MMP_EVENT,
    TaskType.PURCHASE,
    TaskType.PURCHASE_AMOUNT,
];
var OfferType;
(function (OfferType) {
    OfferType["PAY_PER_NEW_PURCHASER"] = "PAY_PER_NEW_PURCHASER";
    OfferType["PAY_PER_INSTALL"] = "PAY_PER_INSTALL";
    OfferType["SEGMENT_OFFER"] = "SEGMENT_OFFER";
    OfferType["REWARDED_PLAYTIME"] = "REWARDED_PLAYTIME";
    OfferType["MMP_EVENTS"] = "MMP_EVENTS";
    OfferType["GENERIC_OFFER"] = "GENERIC_OFFER";
})(OfferType || (exports.OfferType = OfferType = {}));
exports.OfferTypeEnum = zod_1.z.nativeEnum(OfferType);
// @deprecated use OfferType instead
exports.OFFER_TYPE = {
    PAY_PER_NEW_PURCHASER: 'PAY_PER_NEW_PURCHASER',
    PAY_PER_INSTALL: 'PAY_PER_INSTALL',
    SEGMENT_OFFER: 'SEGMENT_OFFER',
    REWARDED_PLAYTIME: 'REWARDED_PLAYTIME',
    MMP_EVENTS: 'MMP_EVENTS',
    GENERIC_OFFER: 'GENERIC_OFFER',
};
exports.DocId = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.FTimestamp = zod_1.z
    .custom((val) => {
    if (typeof val !== 'object') {
        return false;
    }
    if ('seconds' in val && 'nanoseconds' in val) {
        return exports.FTimestampFunc.new(val.seconds, val.nanoseconds);
    }
    if ('_seconds' in val && '_nanoseconds' in val) {
        return exports.FTimestampFunc.new(val._seconds, val._nanoseconds);
    }
    return false;
})
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .transform((val) => {
    if ('seconds' in val && 'nanoseconds' in val) {
        return exports.FTimestampFunc.new(val.seconds, val.nanoseconds);
    }
    if ('_seconds' in val && '_nanoseconds' in val) {
        return exports.FTimestampFunc.new(val._seconds, val._nanoseconds);
    }
    throw new Error('Invalid FTimestamp');
});
exports.FTimestampFunc = {
    toMillis: (timestamp) => {
        if ('seconds' in timestamp) {
            return timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
        }
        else {
            return timestamp['_seconds'] * 1000 + timestamp['_nanoseconds'] / 1000000;
        }
    },
    toDate: (timestamp) => new Date(exports.FTimestampFunc.toMillis(timestamp)),
    new: (seconds, nanoseconds) => {
        return { seconds, nanoseconds };
    },
    now: () => {
        return exports.FTimestampFunc.new(Date.now() / 1000, 0);
    },
    fromMillis: (millis) => {
        return exports.FTimestampFunc.new(Math.floor(millis / 1000), (millis % 1000) * 1000000);
    },
    fromDate: (date) => {
        return exports.FTimestampFunc.new(date.getTime() / 1000, 0);
    },
};
exports.ResourceRewards = zod_1.z.object({
    coins: zod_1.z.number(),
    piggyBanks: zod_1.z.number(),
});
exports.BatchTaskConfig = zod_1.z.object({
    amount: zod_1.z.number(),
    rewards: exports.ResourceRewards,
});
exports.MMPTaskConfigData = zod_1.z.object({
    mmpPostbackEventName: zod_1.z.string(),
    taskDescription: zod_1.z.string(),
    isCashback: zod_1.z.boolean().optional(),
    alternativeEventNames: zod_1.z.array(zod_1.z.string()).optional(),
});
const SurveyTaskConfigData = zod_1.z.object({
    taskDescription: zod_1.z.string(),
    questionSet: zod_1.z.string(),
});
const OfferActivateTaskConfigData = zod_1.z.object({
    taskDescription: zod_1.z.string(),
});
exports.GenericTaskConfig = zod_1.z
    .object({
    taskId: zod_1.z.string(),
    taskType: exports.TaskTypeEnum,
    amount: zod_1.z.number().optional(),
    rewards: exports.ResourceRewards.optional(),
    previousTaskRequirements: zod_1.z.array(zod_1.z.string()),
    delayToUnlockMins: zod_1.z.number().optional(),
    durationToExpireAfterUnlockMins: zod_1.z.number().optional(),
    showUnlockTimer: zod_1.z.boolean().optional(),
    showExpireTimer: zod_1.z.boolean().optional(),
    hideBeforeActive: zod_1.z.boolean().optional(),
    hideAfterExpire: zod_1.z.boolean().optional(),
    valueToPlayback: zod_1.z.number(),
})
    .merge(exports.MMPTaskConfigData.partial());
exports.MMPTaskConfig = exports.GenericTaskConfig.merge(exports.MMPTaskConfigData);
exports.PurchaseTaskConfig = exports.GenericTaskConfig.extend({
    taskDescription: zod_1.z.string(),
});
exports.OfferActivateTaskConfig = exports.GenericTaskConfig.merge(OfferActivateTaskConfigData);
exports.SurveyTaskConfig = exports.GenericTaskConfig.merge(SurveyTaskConfigData);
exports.GenericTask = zod_1.z.object({
    taskId: zod_1.z.string(),
    taskType: exports.TaskTypeEnum,
    isCashback: zod_1.z.boolean().optional(),
    amount: zod_1.z.number(),
    current: zod_1.z.number(),
    rewards: exports.ResourceRewards,
    previousTaskRequirements: zod_1.z.array(zod_1.z.string()),
    completed: zod_1.z.boolean().optional(),
    completedAt: exports.FTimestamp.optional(),
    claimed: zod_1.z.boolean().optional(),
    isUnlocked: zod_1.z.boolean().optional(),
    startTimestamp: exports.FTimestamp.optional(),
    endTimestamp: exports.FTimestamp.optional(),
    showUnlockTimer: zod_1.z.boolean().optional(),
    showExpireTimer: zod_1.z.boolean().optional(),
    hideBeforeActive: zod_1.z.boolean().optional(),
    hideAfterExpire: zod_1.z.boolean().optional(),
});
exports.MMPTask = exports.GenericTask.merge(exports.MMPTaskConfigData);
exports.PurchaseTask = exports.GenericTask.extend({
    taskDescription: zod_1.z.string(),
});
exports.SurveyTask = exports.GenericTask.merge(SurveyTaskConfigData);
exports.OfferActivateTask = exports.GenericTask.merge(OfferActivateTaskConfigData);
exports.BatchPlaytimeConfig = zod_1.z.object({
    batchTasks: zod_1.z.array(exports.BatchTaskConfig).optional(),
    tasksConfigName: zod_1.z.string(),
    coinsPerBatch: zod_1.z.number(),
    pigsPerBatch: zod_1.z.number(),
    batchCount: zod_1.z.number(),
    minutesBetweenBatches: zod_1.z.number(),
});
exports.PartnerAppPayoutInfo = zod_1.z.object({
    revenueRate: zod_1.z.number(),
    payoutScalar: zod_1.z.number(),
    valueToPlaybackByTaskId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
});
exports.ActivatedOffer = zod_1.z.object({
    activationTimeStamp: exports.FTimestamp,
    batchPlaytimeConfig: exports.BatchPlaytimeConfig.optional(),
    coinsPerDollar: zod_1.z.number(),
    dollarsLeft: zod_1.z.number(),
    dollarsSpent: zod_1.z.number(),
    earnedCoins: zod_1.z.number(),
    earnedPiggyBanks: zod_1.z.number(),
    eligibleSpendAmount: zod_1.z.number(),
    expirationTimestamp: exports.FTimestamp,
    hideOfferFromMainViews: zod_1.z.boolean(),
    icon_url: zod_1.z.string(),
    initialVerifiedPlaytimeSeconds: zod_1.z.number().optional(),
    isInstallAttributed: zod_1.z.boolean(),
    isUAOffer: zod_1.z.boolean(),
    lastVerifiedPlaytimeSeconds: zod_1.z.number().optional(),
    mmpAttributionRequiredForEligibility: zod_1.z.boolean(),
    mmpAttributionRequiredForRewards: zod_1.z.boolean(),
    mmpAttributionSupported: zod_1.z.boolean(),
    mmpClickId: zod_1.z.string(),
    mmpProvider: exports.MMPProviderEnum,
    name: zod_1.z.string(),
    offerCampaignId: zod_1.z.string(),
    offerId: zod_1.z.string(),
    offerListItemId: zod_1.z.string(),
    offerType: exports.OfferTypeEnum,
    piggyPerDollar: zod_1.z.number(),
    tasks: zod_1.z.array(exports.GenericTask).optional(),
    unearnedCoins: zod_1.z.number(),
    unearnedPiggyBanks: zod_1.z.number(),
    unifiedAppID: zod_1.z.string(),
    updatedAt: exports.FTimestamp,
    userId: zod_1.z.string(),
    valueStatement: zod_1.z.string().optional(), // Transitioning this to be a required field now that we are dynamically computing this.
    offerQuality: zod_1.z.string().optional(),
    /** Offers that are activated but we know will never receive MMP events. Used in iOS to allow users to install apps without having any tracking enabled. */
    noMMPTracking: zod_1.z.boolean().optional(),
    /** This is the payout info for the partner app. It is used to calculate the payouts for the offer and should not be sent to the clients */
    partnerAppPayoutInfo: exports.PartnerAppPayoutInfo.optional(),
});
exports.ActivatedOfferDoc = exports.ActivatedOffer.merge(exports.DocId);
exports.MmpCampaignStatus = zod_1.z.object({
    status: exports.MmpCampaignStatusTypeEnum,
    updatedAt: exports.FTimestamp,
    additionalInfo: zod_1.z.record(zod_1.z.any()),
});
exports.PublisherCampaignCpiWindow = zod_1.z.object({
    cpi: zod_1.z.number(),
    endDate: exports.FTimestamp.nullable(),
});
exports.EventNameCosts = zod_1.z.record(zod_1.z.number());
exports.EventTypeCosts = zod_1.z.record(exports.UserEventTypesEnum, zod_1.z.number());
// export type EventTypeCosts = {
//   [eventType in UserEventTypes]?: number;
//   [eventType in UserEventTypes]?: number;
// };
exports.PublisherCampaignEventCostWindow = zod_1.z.object({
    eventNameCosts: exports.EventNameCosts.optional(),
    eventTypeCosts: exports.EventTypeCosts.optional(),
    endDate: exports.FTimestamp.nullable(),
});
exports.UserTargetingValueType = zod_1.z.union([zod_1.z.number(), zod_1.z.string(), zod_1.z.boolean(), zod_1.z.null()]);
exports.UserTargetingOperator = {
    EQUALS: '==',
    NOT_EQUALS: '!=',
    LESS_THAN: '<',
    LESS_THAN_OR_EQUAL: '<=',
    GREATER_THAN: '>',
    GREATER_THAN_OR_EQUAL: '>=',
    EQUALS_IGNORE_CASE: 'equalsIgnoreCase',
    NOT_EQUALS_IGNORE_CASE: 'notEqualsIgnoreCase',
};
exports.UserTargetingOperatorEnum = zod_1.z.nativeEnum(exports.UserTargetingOperator);
exports.UserTargetingCondition = zod_1.z.object({
    left: exports.UserTargetingValueType,
    operator: exports.UserTargetingOperatorEnum,
    right: exports.UserTargetingValueType,
});
exports.UserTargeting = zod_1.z.object({
    conditions: zod_1.z.array(exports.UserTargetingCondition).optional(),
    functions: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.PartnerAppCampaignSettings = zod_1.z.object({
    appAllowed: zod_1.z.boolean(),
    dailyInstallCap: zod_1.z.number().nullable(),
    hourlyInstallCap: zod_1.z.number().nullable(),
});
exports.CampaignCostWindow = zod_1.z.object({
    defaultCost: zod_1.z.object({
        eventNameCosts: exports.EventNameCosts.optional(),
        eventTypeCosts: exports.EventTypeCosts.optional(),
    }),
    subSourceCostOverrides: zod_1.z.record(zod_1.z.string(), zod_1.z.object({
        eventNameCosts: exports.EventNameCosts.optional(),
        eventTypeCosts: exports.EventTypeCosts.optional(),
    })),
    endDate: exports.FTimestamp.nullable(),
});
exports.PublisherCampaign = zod_1.z.object({
    appDescription: zod_1.z.string(),
    appRating: zod_1.z.number(),
    categories: zod_1.z.array(zod_1.z.string()),
    costMMPProvider: exports.MMPProviderEnum,
    countryTargeting: zod_1.z.array(countryCode_1.CountryCodeEnum),
    cpeConfig: zod_1.z.array(exports.PublisherCampaignEventCostWindow).optional(),
    dailyInstallCap: zod_1.z.number(),
    featuredGraphic: zod_1.z.string(),
    gameName: zod_1.z.string(),
    hourlyInstallCap: zod_1.z.number(),
    iconUrl: zod_1.z.string(),
    id: zod_1.z.string(),
    isActive: zod_1.z.boolean(),
    isNonAppOffer: zod_1.z.boolean().optional(),
    mmpLink: zod_1.z.string(),
    mmpProvider: exports.MMPProviderEnum,
    // offerIds: z.array(DocumentReference),  // TODO: Figure out how to better support these
    offerIds: zod_1.z.array(zod_1.z.any()),
    pbrCampaignName: zod_1.z.string(),
    platform: exports.GamePlatformEnum,
    publisherCampaignName: zod_1.z.string(),
    publisherInternalId: zod_1.z.string(),
    screenshots: zod_1.z.array(zod_1.z.string()),
    storeLink: zod_1.z.string(),
    unifiedAppId: zod_1.z.string(),
    userTargeting: exports.UserTargeting,
    videoUrl: zod_1.z.string().nullable(),
    mmpCampaignStatus: exports.MmpCampaignStatus,
    customMmpData: zod_1.z.record(zod_1.z.any()),
    createdAt: exports.FTimestamp.optional(),
    updatedAt: exports.FTimestamp.optional(),
    partnerAppSettings: zod_1.z.record(zod_1.z.string(), exports.PartnerAppCampaignSettings).optional(),
    campaignCostWindow: zod_1.z.array(exports.CampaignCostWindow).optional(),
});
exports.AdminEventVerificationDTO = zod_1.z.object({
    /** This should be the user generating this event */
    adminId: zod_1.z.string(),
    clickId: zod_1.z.string(),
    rawEventName: zod_1.z.string().nullable(),
    eventName: zod_1.z.string().nullable(),
    eventType: exports.UserEventTypesEnum,
    eventTimestamp: exports.FTimestamp,
});
exports.Publisher = zod_1.z.object({
    publisherName: zod_1.z.string(),
});
exports.GetExpTransactionsQuery = zod_1.z.object({
    userId: zod_1.z.string(),
    key: zod_1.z.string(),
});
exports.OffersFilteredByCategoryQuery = zod_1.z.object({
    categories: zod_1.z.string(), // comma separated list of GameCategory
    limit: zod_1.z.coerce.number().positive().optional(),
});
exports.SurveyResponseBody = zod_1.z.object({
    answer: zod_1.z.string(),
});
exports.SurveyAnswerOption = zod_1.z.object({
    answer: zod_1.z.string(),
    image: zod_1.z.string().optional(),
    type: zod_1.z.string().optional(),
});
exports.SurveyQuestion = zod_1.z.object({
    questionId: zod_1.z.string(),
    question: zod_1.z.string(),
    type: zod_1.z.string(),
    reward: exports.ResourceRewards,
    fullAnswers: zod_1.z.array(exports.SurveyAnswerOption),
});
exports.SurveyQuestionSet = zod_1.z.object({
    id: zod_1.z.string(),
    questionSet: zod_1.z.string(),
    questions: zod_1.z.array(exports.SurveyQuestion),
    questionEndingUrl: zod_1.z.string(),
});
exports.SurveyResponse = zod_1.z.object({
    answer: zod_1.z.string(),
    questionId: zod_1.z.string(),
    createdAt: exports.FTimestamp,
});
exports.SurveyInstance = zod_1.z.object({
    id: zod_1.z.string(),
    questionSet: zod_1.z.string(),
    questions: zod_1.z.array(exports.SurveyQuestion),
    questionEndingUrl: zod_1.z.string(),
    answers: zod_1.z.array(exports.SurveyResponse),
    complete: zod_1.z.boolean(),
    createdAt: exports.FTimestamp,
    taskId: zod_1.z.string().optional(),
    offerId: zod_1.z.string().optional(),
});
exports.ClickUrlResponse = zod_1.z.object({
    clickId: zod_1.z.string(),
    templateUrl: zod_1.z.string(),
    url: zod_1.z.string(),
});
/** @deprecated use `ActivateOfferBody` and the new Nest endpoint */
exports.ActivateOfferStart = zod_1.z.object({
    userId: zod_1.z.string(),
    offerId: zod_1.z.string(),
    clickId: zod_1.z.string(),
});
exports.ActivateOfferBody = zod_1.z.object({
    campaignId: zod_1.z.string(),
    offerId: zod_1.z.string(),
    clickId: zod_1.z.string(),
    noMMPTracking: zod_1.z.boolean().optional(),
    country: countryCode_1.CountryCodeEnum,
});
exports.OrderStart = zod_1.z.object({
    amount: zod_1.z.number(),
    userId: zod_1.z.string(),
    data: zod_1.z.any(),
});
exports.TremendousPayment = zod_1.z.object({
    fees: zod_1.z.number(),
    subtotal: zod_1.z.number(),
    total: zod_1.z.number(),
});
exports.TremendousValue = zod_1.z.object({
    currency_code: zod_1.z.string(),
    denomination: zod_1.z.number(),
});
exports.TremendousRecipient = zod_1.z.object({
    email: zod_1.z.string(),
    name: zod_1.z.string(),
    phone: zod_1.z.string(),
});
exports.TremendousDelivery = zod_1.z.object({
    link: zod_1.z.string(),
    method: zod_1.z.string(),
    status: zod_1.z.string(),
});
exports.TremendousReward = zod_1.z.object({
    created_at: zod_1.z.string(),
    delivery: exports.TremendousDelivery,
    id: zod_1.z.string(),
    order_id: zod_1.z.string(),
    recipient: exports.TremendousRecipient,
    value: exports.TremendousValue,
});
exports.TremendousOrder = zod_1.z.object({
    campaign_id: zod_1.z.string(),
    channel: zod_1.z.string(),
    created_at: zod_1.z.string(),
    external_id: zod_1.z.any(),
    id: zod_1.z.string(),
    payment: exports.TremendousPayment,
    rewards: zod_1.z.array(exports.TremendousReward),
    status: zod_1.z.string(),
});
exports.TremendousOrderData = zod_1.z.object({
    order: exports.TremendousOrder,
});
exports.OrderData = zod_1.z.object({
    orderID: zod_1.z.string(),
    amount: zod_1.z.number(),
    currencyTransactionID: zod_1.z.string(),
    orderData: exports.TremendousOrderData,
    piggyAmount: zod_1.z.number(),
    userId: zod_1.z.string(),
});
exports.PublisherCampaignFE = exports.PublisherCampaign.pick({
    appDescription: true,
    appRating: true,
    categories: true,
    id: true,
    featuredGraphic: true,
    gameName: true,
    iconUrl: true,
    mmpLink: true,
    screenshots: true,
    unifiedAppId: true,
    videoUrl: true,
    mmpProvider: true,
    publisherCampaignName: true,
    platform: true,
    storeLink: true,
    customMmpData: true,
});
exports.UserBalanceFE = zod_1.z.object({
    userId: zod_1.z.string(),
    coins: zod_1.z.number(),
    piggyBanks: zod_1.z.number(),
    reachedPiggyBanksFromMinigameThreshold: zod_1.z.boolean(),
});
exports.ExpUser = zod_1.z.object({
    coins: zod_1.z.number(),
    piggyBanks: zod_1.z.number(),
    createdAt: exports.FTimestamp,
    updatedAt: exports.FTimestamp,
    onboarding_complete: zod_1.z.boolean(),
});
exports.ExpUserDoc = exports.ExpUser.merge(exports.DocId);
exports.MmpClickIds = zod_1.z.object({
    createdAt: exports.FTimestamp,
    lastClickedAt: exports.FTimestamp,
    adid: zod_1.z.string().nullable(),
    campaignId: zod_1.z.string(),
    offerCampaignName: zod_1.z.string(),
    clickId: zod_1.z.string(),
    clickTimestamp: exports.FTimestamp, // This or `createAt should get deprecated. They're effectively equivalent data but I think older clicks might have used `clickTimestamp`
    clickedLink: zod_1.z.string(),
    devicePlatform: zod_1.z.string(),
    isOfferActivated: zod_1.z.boolean(),
    linkPlatform: zod_1.z.string(),
    mmpProvider: zod_1.z.string(),
    name: zod_1.z.string(),
    offerId: zod_1.z.string(),
    unifiedAppId: zod_1.z.string(),
    userAgent: zod_1.z.string(),
    userId: zod_1.z.string(),
    appType: exports.AppTypeEnum,
    subSourceId: zod_1.z.string(),
});
exports.RewardsObject = zod_1.z.object({
    claimedDate: exports.FTimestamp,
    earnedCoins: zod_1.z.number(),
    earnedDate: exports.FTimestamp,
    earnedPiggy: zod_1.z.number(),
    emailId: zod_1.z.string(),
    gameName: zod_1.z.string(),
    isInitialParse: zod_1.z.boolean(),
    isPartiallyRewarded: zod_1.z.boolean(),
    offerCampaignId: zod_1.z.string(),
    offerLisItemId: zod_1.z.string(),
    orderDate: exports.FTimestamp,
    orderId: zod_1.z.string(),
    platform: zod_1.z.string(),
    platformsIconUrl: zod_1.z.array(zod_1.z.any()),
    price: zod_1.z.number(),
    reason: zod_1.z.string(),
    unifiedAppId: zod_1.z.string(),
    userId: zod_1.z.string(),
});
/** This type is used in the iOS backend and attempting to start to move rewards to a more consistent format across the different types */
exports.Reward = zod_1.z.object({
    /** Generic field depending on the reward type (if receipts it's the purchase price, if playtime it's the number of minutes) */
    amount: zod_1.z.number(),
    claimedDate: exports.FTimestamp.nullable(),
    description: zod_1.z.string().optional(),
    earnedCoins: zod_1.z.number(),
    earnedDate: exports.FTimestamp,
    earnedPiggy: zod_1.z.number(),
    gameName: zod_1.z.string(),
    iconUrl: zod_1.z.string(),
    isUnlocked: zod_1.z.boolean(),
    isPartiallyRewarded: zod_1.z.boolean(),
    offerCampaignId: zod_1.z.string(),
    offerId: zod_1.z.string(),
    offerSubId: zod_1.z.string(),
    orderDate: exports.FTimestamp.optional(),
    reason: zod_1.z.string(), // TODO: We should create an enum for this
    taskId: zod_1.z.string().optional(),
    unifiedAppId: zod_1.z.string(),
    userId: zod_1.z.string(),
    // Removed (might be needed as optional for receipts)
    // emailId: z.string(),
    // orderId: z.string(),
    // isInitialParse: z.boolean(),
});
exports.RewardDoc = exports.Reward.merge(exports.DocId);
const UserStateFE = zod_1.z.object({
    expUserObject: exports.ExpUser,
    rewards: zod_1.z.array(exports.RewardsObject),
    activatedOffers: zod_1.z.array(exports.ActivatedOffer),
});
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "Active";
    UserStatus["BLOCKED"] = "Blocked";
    UserStatus["FROZEN"] = "Frozen";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
exports.UserStatusEnum = zod_1.z.nativeEnum(UserStatus);
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["UNVERIFIED"] = "Unverified";
    VerificationStatus["VERIFIED"] = "Verified";
    VerificationStatus["STRIPE_REJECTED"] = "STRIPE_REJECTED";
    VerificationStatus["PLAYBACK_DUPLICATE_REJECTED"] = "PLAYBACK_DUPLICATE_REJECTED";
    VerificationStatus["COUNTRY_MISMATCH"] = "COUNTRY_MISMATCH";
    VerificationStatus["COUNTRY_INELIGIBLE"] = "COUNTRY_INELIGIBLE";
})(VerificationStatus || (exports.VerificationStatus = VerificationStatus = {}));
exports.VerificationStatusEnum = zod_1.z.nativeEnum(VerificationStatus);
exports.UserEventTypeMapping = zod_1.z
    .object({
    eventName: zod_1.z.string(),
    eventType: exports.UserEventTypesEnum,
    providerScope: exports.MMPProviderEnum,
    campaignIdScope: zod_1.z.string().nullable(),
})
    .refine((data) => (data.campaignIdScope === null) !== (data.providerScope === undefined), {
    message: 'Either campaignIdScope or providerScope must be defined, but not both.',
});
exports.EventVerification = zod_1.z.object({
    /**
     * The ID of the source that triggered this event. If this is a verified by a Singular MMP, then this will be the ID of the postback record.
     */
    sourceId: zod_1.z.string(),
    clickId: zod_1.z.string(),
    createdAt: exports.FTimestamp,
    lastUpdated: exports.FTimestamp,
    /** The raw event name we receive from the postbacks. If it didn't original from a postback this is generally null. */
    rawEventName: zod_1.z.string().nullable(),
    eventName: zod_1.z.string().nullable(),
    eventType: exports.UserEventTypesEnum,
    eventTimestamp: exports.FTimestamp,
    unifiedAppId: zod_1.z.string(),
    userId: zod_1.z.string(),
    verifyMethod: exports.VerificationMethodEnum,
    verifyProvider: exports.MMPProviderEnum,
    campaignId: zod_1.z.string(),
    campaignName: zod_1.z.string(),
    offerId: zod_1.z.string().nullable(), // null only for historical data
    pbrRevenue: zod_1.z.number(),
    appType: exports.AppTypeEnum,
    subSourceId: zod_1.z.string(),
});
// This is the shared "User" object used in the "User" collection.
// Each app may have their own extension of this, but should at least
// have these fields.
exports.UserCore = zod_1.z.object({
    IPAddress: zod_1.z.object({
        lastLogin: zod_1.z.string(),
        registration: zod_1.z.string(),
    }),
    appType: exports.AppTypeEnum,
    clientToken: zod_1.z.string().optional(),
    country: zod_1.z.string(),
    createdAt: exports.FTimestamp,
    email: zod_1.z.string().nullable(), // Nullable for Playtest Rewards, but required for Playback
    identityVerification: zod_1.z.object({
        attempts: zod_1.z.number(),
        status: zod_1.z.string(),
        failureReason: zod_1.z.string().nullable().optional(),
        verificationSessionId: zod_1.z.string().nullable().optional(),
        updatedAt: exports.FTimestamp.nullable(),
        isAdmin: zod_1.z.boolean().optional(),
        adminReason: zod_1.z.string().nullable().optional(),
    }),
    lastActivatedOffer: exports.FTimestamp.nullable(),
    lastSessionTime: exports.FTimestamp,
    signUpIPCountry: zod_1.z.string(),
});
exports.UserCoreDoc = exports.UserCore.merge(exports.DocId);
exports.DailyStreak = zod_1.z.object({
    streakCount: zod_1.z.number().nonnegative(),
    lastAdWatch: exports.FTimestamp.nullable(),
});
exports.PBRUserDoc = exports.UserCoreDoc.extend({
    allGiftCardValueRedeemed: zod_1.z.number(),
    allTimeCoinsEarned: zod_1.z.number(),
    allTimePiggyBanksEarned: zod_1.z.number(),
    firstName: zod_1.z.string(),
    piggyBanks: zod_1.z.number(),
    platform: zod_1.z.string(),
    points: zod_1.z.number(),
    role: zod_1.z.string(),
    userStatus: zod_1.z.string().optional(),
    gmailConnectionStatus: zod_1.z.string().optional(),
    onboardingStep: zod_1.z.string().optional(),
    currentStep: zod_1.z.string().optional(),
    googleSubId: zod_1.z.string().optional(),
    dailyStreak: exports.DailyStreak.optional(),
});
exports.GrantNotification = zod_1.z.object({
    0: zod_1.z.boolean(),
    30: zod_1.z.boolean(),
    7: zod_1.z.boolean(),
    date: exports.FTimestamp,
});
exports.UserConnectedEmail = zod_1.z.object({
    connectedEmail: zod_1.z.string(),
    connector: zod_1.z.string(),
    createdAt: exports.FTimestamp,
    encryptedRefreshToken: zod_1.z.string().optional(),
    grantNotification: exports.GrantNotification.nullable(),
    id: zod_1.z.string().optional(),
    isMailServiceEnabled: zod_1.z.boolean(),
    isPrimary: zod_1.z.boolean().optional().nullable(),
    parseDate: exports.FTimestamp.nullable(),
    lastAuditParseAt: exports.FTimestamp.optional().nullable(),
    refreshToken: zod_1.z.string().optional(),
    updatedAt: exports.FTimestamp.optional(),
    userId: zod_1.z.string(),
});
exports.OfferwallAdditionalParams = zod_1.z.object({
    // Currently unused, but leaving for time being
    info1: zod_1.z.string().optional(),
    info2: zod_1.z.string().optional(),
    info3: zod_1.z.string().optional(),
});
/** This is the info sent up from the device (e.g. on login). */
exports.DeviceInfo = zod_1.z.object({
    uniqueId: zod_1.z.string().optional(),
    adid: zod_1.z.string().nullable(),
    isLimitAdTrackingEnabled: zod_1.z.boolean().nullable(),
    os: zod_1.z.string().optional(),
    manufacturer: zod_1.z.string().optional(),
    deviceName: zod_1.z.string().optional(),
    model: zod_1.z.string().optional(),
    osVersion: zod_1.z.string().optional(),
    platform: zod_1.z.string().optional(),
    FCMToken: zod_1.z.string().nullable().optional(),
    appsflyerId: zod_1.z.string().optional(),
    appUsageAccess: zod_1.z.boolean().optional(),
    appInstanceId: zod_1.z.string().nullable().optional(),
    additionalOfferwallParams: exports.OfferwallAdditionalParams.optional(),
});
/** This is all the information store in the Device collection - primarily data from DeviceInfo */
exports.Device = zod_1.z.object({
    FCMToken: zod_1.z.string(),
    aaid: zod_1.z.string().nullable(),
    appUsageAccess: zod_1.z.boolean(),
    appsflyerId: zod_1.z.string().nullable(),
    appInstanceId: zod_1.z.string().optional(),
    createdAt: exports.FTimestamp,
    deviceName: zod_1.z.string().nullable(),
    history: zod_1.z.array(zod_1.z.any()),
    isAppDeleted: zod_1.z.boolean().optional(),
    ip: zod_1.z.string(),
    lastLogin: exports.FTimestamp.optional(),
    manufacturer: zod_1.z.string().nullable(),
    model: zod_1.z.string().nullable(),
    os: zod_1.z.string().nullable(),
    osVersion: zod_1.z.string().nullable(),
    platform: zod_1.z.string(),
    topics: zod_1.z.array(zod_1.z.string()),
    uniqueId: zod_1.z.string().optional(), // Android only
    unsubscribedTopics: zod_1.z.array(zod_1.z.string()),
    updatedAt: exports.FTimestamp,
    userId: zod_1.z.string(),
    hasShownATTPrompt: zod_1.z.boolean().optional(), // iOS only
});
exports.DeviceDoc = exports.Device.merge(exports.DocId);
exports.CombinedUser = zod_1.z.object({
    user: exports.UserCoreDoc,
    expUser: exports.ExpUserDoc,
});
var FrozenAccountReasons;
(function (FrozenAccountReasons) {
    FrozenAccountReasons["REACHED_MMP_PIGGY_BANKS_REWARD_THRESHOLD"] = "REACHED_MMP_PIGGY_BANKS_REWARD_THRESHOLD";
    FrozenAccountReasons["INVALID_MMP_TASK_TIME_COMPLETION"] = "INVALID_MMP_TASK_TIME_COMPLETION";
    FrozenAccountReasons["POSTBACK_INTERNAL_REJECTION_REASON"] = "POSTBACK_INTERNAL_REJECTION_REASON";
    FrozenAccountReasons["QUICK_HIGH_VALUE_WITHDRAWAL_NEW_ACCOUNT"] = "QUICK_HIGH_VALUE_WITHDRAWAL_NEW_ACCOUNT";
})(FrozenAccountReasons || (exports.FrozenAccountReasons = FrozenAccountReasons = {}));
exports.FrozenAccountReasonsEnum = zod_1.z.nativeEnum(FrozenAccountReasons);
var UserStatusAdminReason;
(function (UserStatusAdminReason) {
    UserStatusAdminReason["ADMIN_REQUEST_FRAUD"] = "Fraud";
    UserStatusAdminReason["ADMIN_REQUEST_OTHER"] = "Other";
    UserStatusAdminReason["ADMIN_REQUEST_CLEARED"] = "Clear";
})(UserStatusAdminReason || (exports.UserStatusAdminReason = UserStatusAdminReason = {}));
exports.UserStatusAdminReasonEnum = zod_1.z.nativeEnum(UserStatusAdminReason);
exports.UserStatusChangeDetails = zod_1.z.object({
    previous: zod_1.z.string(),
    new: zod_1.z.string(),
    reason: zod_1.z.union([exports.FrozenAccountReasonsEnum, exports.UserStatusAdminReasonEnum]),
    details: zod_1.z.object({}).catchall(zod_1.z.any()).optional(),
});
var AdminLogType;
(function (AdminLogType) {
    AdminLogType["USER_STATUS_CHANGE"] = "USER_STATUS_CHANGE";
    AdminLogType["USER_VERIFICATION_CHANGE"] = "USER_VERIFICATION_CHANGE";
})(AdminLogType || (exports.AdminLogType = AdminLogType = {}));
exports.AdminLogTypeEnum = zod_1.z.nativeEnum(AdminLogType);
exports.AdminLog = zod_1.z.object({
    createdAt: exports.FTimestamp,
    type: exports.AdminLogTypeEnum,
    details: exports.UserStatusChangeDetails, // Could union this with other possible types late
});
exports.DailyStreakConfig = zod_1.z.object({
    defaultPiggyBanks: zod_1.z.number(),
    bonusDayPiggyBanks: zod_1.z.record(zod_1.z.number()),
    /** This is the UTC offset in hours that the timers reset each day */
    resetTimeUTCOffset: zod_1.z.number(),
    extensionCost: zod_1.z.object({
        coins: zod_1.z.number(),
        piggyBanks: zod_1.z.number(),
    }),
});
var UserFeedbackUpdateType;
(function (UserFeedbackUpdateType) {
    UserFeedbackUpdateType["StarsRate"] = "STARS_RATE";
    UserFeedbackUpdateType["TextFeedback"] = "TEXT_FEEDBACK";
    UserFeedbackUpdateType["RateLater"] = "RATE_LATER";
})(UserFeedbackUpdateType || (exports.UserFeedbackUpdateType = UserFeedbackUpdateType = {}));
exports.UserFeedbackUpdateTypeEnum = zod_1.z.nativeEnum(UserFeedbackUpdateType);
exports.UserRatingFeedbackBody = zod_1.z.object({
    rating: zod_1.z.number().optional(),
    feedback: zod_1.z.string().optional(),
    type: exports.UserFeedbackUpdateTypeEnum,
});
var AB_TESTING_NAMES;
(function (AB_TESTING_NAMES) {
    AB_TESTING_NAMES["UNLOCK_ALL_OFFERS"] = "UNLOCK_ALL_OFFERS";
    AB_TESTING_NAMES["MINIMUM_REDEMPTION"] = "25_USD_FIRST_REDEEM";
    AB_TESTING_NAMES["DAILY_STREAK"] = "DAILY_STREAK";
    AB_TESTING_NAMES["DYNAMIC_PROFITABILITY_SCALING"] = "DYNAMIC_PROFITABILITY_SCALING";
    AB_TESTING_NAMES["BIG_VERTICAL_OFFER_LIST_TEST"] = "BIG_VERTICAL_OFFER_LIST_TEST";
})(AB_TESTING_NAMES || (exports.AB_TESTING_NAMES = AB_TESTING_NAMES = {}));
exports.ABTestingNamesEnum = zod_1.z.nativeEnum(AB_TESTING_NAMES);
var AB_UNLOCK_ALL_OFFERS_GROUP;
(function (AB_UNLOCK_ALL_OFFERS_GROUP) {
    AB_UNLOCK_ALL_OFFERS_GROUP["UNLOCK_ALL_OFFERS_200"] = "200_PIGS_UNLOCKS_ALL_OFFERS";
    AB_UNLOCK_ALL_OFFERS_GROUP["CONTROL"] = "CONTROL";
})(AB_UNLOCK_ALL_OFFERS_GROUP || (exports.AB_UNLOCK_ALL_OFFERS_GROUP = AB_UNLOCK_ALL_OFFERS_GROUP = {}));
exports.ABUnlockAllOffersGroupEnum = zod_1.z.nativeEnum(AB_UNLOCK_ALL_OFFERS_GROUP);
var BIG_VERTICAL_OFFER_LIST_TEST_GROUP;
(function (BIG_VERTICAL_OFFER_LIST_TEST_GROUP) {
    BIG_VERTICAL_OFFER_LIST_TEST_GROUP["BIG_VERTICAL_OFFER_LIST"] = "BIG_VERTICAL_OFFER_LIST";
    BIG_VERTICAL_OFFER_LIST_TEST_GROUP["CONTROL"] = "CONTROL";
})(BIG_VERTICAL_OFFER_LIST_TEST_GROUP || (exports.BIG_VERTICAL_OFFER_LIST_TEST_GROUP = BIG_VERTICAL_OFFER_LIST_TEST_GROUP = {}));
exports.BigVerticalOfferListGroupEnum = zod_1.z.nativeEnum(BIG_VERTICAL_OFFER_LIST_TEST_GROUP);
var AB_TEST_MINIMUM_REDEMPTION_GROUP;
(function (AB_TEST_MINIMUM_REDEMPTION_GROUP) {
    AB_TEST_MINIMUM_REDEMPTION_GROUP["MIN_25_USD_FIRST_REDEEM"] = "MIN_25_USD_FIRST_REDEEM";
    AB_TEST_MINIMUM_REDEMPTION_GROUP["CONTROL"] = "CONTROL";
})(AB_TEST_MINIMUM_REDEMPTION_GROUP || (exports.AB_TEST_MINIMUM_REDEMPTION_GROUP = AB_TEST_MINIMUM_REDEMPTION_GROUP = {}));
exports.ABTestMinimumRedemptionGroupEnum = zod_1.z.nativeEnum(AB_TEST_MINIMUM_REDEMPTION_GROUP);
exports.AB_UNLOCK_EARNED_PIGGY = 200;
var ABTestDailyStreakGroup;
(function (ABTestDailyStreakGroup) {
    ABTestDailyStreakGroup["CONTROL"] = "CONTROL";
    ABTestDailyStreakGroup["ENABLED"] = "ENABLED";
})(ABTestDailyStreakGroup || (exports.ABTestDailyStreakGroup = ABTestDailyStreakGroup = {}));
exports.ABTestDailyStreakGroupEnum = zod_1.z.nativeEnum(ABTestDailyStreakGroup);
var ABTestDynamicProfitabilityScalingGroup;
(function (ABTestDynamicProfitabilityScalingGroup) {
    ABTestDynamicProfitabilityScalingGroup["CONTROL"] = "CONTROL";
    ABTestDynamicProfitabilityScalingGroup["TEST_DYNAMIC_SCALING"] = "TEST_DYNAMIC_SCALING";
})(ABTestDynamicProfitabilityScalingGroup || (exports.ABTestDynamicProfitabilityScalingGroup = ABTestDynamicProfitabilityScalingGroup = {}));
exports.ABTestDynamicProfitabilityScalingGroupEnum = zod_1.z.nativeEnum(ABTestDynamicProfitabilityScalingGroup);
exports.ABTestGroupValues = zod_1.z.union([
    exports.ABUnlockAllOffersGroupEnum,
    exports.ABTestMinimumRedemptionGroupEnum,
    exports.ABTestDailyStreakGroupEnum,
    exports.ABTestDynamicProfitabilityScalingGroupEnum,
    exports.BigVerticalOfferListGroupEnum,
]);
exports.NativeAppDetails = zod_1.z.object({
    versionName: zod_1.z.string(),
    versionCode: zod_1.z.string(),
});
exports.PiggyBankChestConfig = zod_1.z.object({
    rewards: zod_1.z.array(zod_1.z.object({
        dropRate: zod_1.z.number(),
        reward: exports.ResourceRewards,
    })),
    numberOfChancesPerPeriod: zod_1.z.number(),
    price: zod_1.z.object({
        coins: zod_1.z.number(),
    }),
    refreshInterval: zod_1.z.object({
        unit: zod_1.z.string(),
        value: zod_1.z.number(),
    }),
});
exports.UserStats = zod_1.z.object({
    id: zod_1.z.string(),
    piggyEarned: zod_1.z.number().optional(),
    pbrRevenue: zod_1.z.number().optional(),
    purchasePostbackCount: zod_1.z.number().optional(),
    ltvD14Verified: zod_1.z
        .record(zod_1.z.string(), zod_1.z.object({
        publisherRevenue: zod_1.z.number(),
        installTime: exports.FTimestamp,
    }))
        .optional(),
});
exports.UnclaimedReward = zod_1.z.object({
    title: zod_1.z.string(),
    subtitle: zod_1.z.string().optional(),
    earnedCoins: zod_1.z.number(),
    earnedPiggy: zod_1.z.number(),
    iconUrl: zod_1.z.string(),
    earnedDate: exports.FTimestamp,
});
exports.NamedFunction = zod_1.z.object({
    name: zod_1.z.string(),
    function: zod_1.z.string(),
});
exports.UserTargetingConfig = zod_1.z.object({
    namedFunctions: zod_1.z.array(exports.NamedFunction),
});
exports.PLAYBACK_GAME_CATEGORIES_MAPPING = [
    {
        rowName: 'actionRow',
        playbackCategory: 'Action',
        categories: ['game_action', 'GAME_ACTION', 'game_arcade', 'GAME_ARCADE', 7001, '7001'],
        order: 5,
    },
    {
        rowName: 'adventureRow',
        playbackCategory: 'Adventure',
        categories: ['game_adventure', 'GAME_ADVENTURE', 7002, '7002'],
        order: 7,
    },
    {
        rowName: 'casualRow',
        playbackCategory: 'Casual',
        categories: ['game_casual', 'GAME_CASUAL', 7003, '7003'],
        order: 2,
    },
    {
        rowName: 'boardRow',
        playbackCategory: 'Board',
        categories: ['game_board', 'GAME_BOARD', 7004, '7004'],
        order: 9,
    },
    {
        rowName: 'cardRow',
        playbackCategory: 'Card',
        categories: ['game_card', 'GAME_CARD', 7005, '7005'],
        order: 10,
    },
    {
        rowName: 'casinoRow',
        playbackCategory: 'Casino',
        categories: ['game_casino', 'GAME_CASINO', 7006, '7006'],
        order: 6,
    },
    {
        rowName: 'educationalRow',
        playbackCategory: 'Educational',
        categories: ['game_educational', 'GAME_EDUCATIONAL'],
        order: 15,
    },
    {
        rowName: 'familyRow',
        playbackCategory: 'Family',
        categories: [
            'family',
            'family_action',
            'family_braingames',
            'family_create',
            'family_education',
            'family_musicvideo',
            'family_pretend',
            7009,
            '7009',
        ],
        order: 17,
    },
    {
        rowName: 'musicRow',
        playbackCategory: 'Music',
        categories: ['game_music', 'GAME_MUSIC', 7011, '7011'],
        order: 12,
    },
    {
        rowName: 'puzzleRow',
        playbackCategory: 'Puzzle',
        categories: ['game_puzzle', 'GAME_PUZZLE', 7012, '7012'],
        order: 3,
    },
    {
        rowName: 'racingRow',
        playbackCategory: 'Racing',
        categories: ['game_racing', 'GAME_RACING', 7013, '7013'],
        order: 13,
    },
    {
        rowName: 'roleplayRow',
        playbackCategory: 'Role Playing',
        categories: ['game_role_playing', 'GAME_ROLE_PLAYING', 7014, '7014'],
        order: 1,
    },
    {
        rowName: 'simulationRow',
        playbackCategory: 'Simulation',
        categories: ['game_simulation', 'GAME_SIMULATION', 7015, '7015'],
        order: 8,
    },
    {
        rowName: 'sportsRow',
        playbackCategory: 'Sports',
        categories: ['game_sports', 'GAME_SPORTS', 7016, '7016'],
        order: 11,
    },
    {
        rowName: 'strategyRow',
        playbackCategory: 'Strategy',
        categories: ['game_strategy', 'GAME_STRATEGY', 7017, '7017'],
        order: 4,
    },
    {
        rowName: 'triviaRow',
        playbackCategory: 'Trivia',
        categories: ['game_trivia', 'GAME_TRIVIA', 7018, '7018'],
        order: 16,
    },
    {
        rowName: 'wordRow',
        playbackCategory: 'Word',
        categories: ['game_word', 'GAME_WORD', 7019, '7019'],
        order: 14,
    },
];
exports.AlternativeNameDiffsSchema = zod_1.z.object({
    mmpPostbackEventName: zod_1.z.string(),
    changes: zod_1.z.array(zod_1.z.string()),
});
exports.AlternativeNameDiffsRequestSchema = zod_1.z.array(exports.AlternativeNameDiffsSchema);
exports.PartnerAppStylingConfig = zod_1.z.object({
    primaryColor: zod_1.z.string(),
    headerImageUrl: zod_1.z.string().nullable(),
    currencyIconUrl: zod_1.z.string(),
    currencyIconSize: zod_1.z.number().optional(),
});
exports.PartnerAppFeatureConfig = zod_1.z.object({
    homeButton: zod_1.z.boolean(), // Whether the home button is shown in the navigation bar
});
exports.PartnerAppOfferSettings = zod_1.z.object({
    appAllowed: zod_1.z.boolean(),
    dailyInstallCap: zod_1.z.number().nullable(),
    hourlyInstallCap: zod_1.z.number().nullable(),
    revenueRateOverride: zod_1.z.number().nullable(),
    payoutScalar: zod_1.z.number().nullable(),
});
exports.PartnerApp = zod_1.z.object({
    id: zod_1.z.string(),
    subSourceId: zod_1.z.string(),
    partnerName: zod_1.z.string().optional(),
    partnerAppName: zod_1.z.string().optional(),
    stylingConfig: exports.PartnerAppStylingConfig.optional(),
    featureConfig: exports.PartnerAppFeatureConfig.optional(),
    defaultRevenueRate: zod_1.z.number(),
    rewardRate: zod_1.z.number(),
    currencyConversionRate: zod_1.z.number(),
    currencyName: zod_1.z.string(),
    /** Token used to sign the postback signature */
    s2sToken: zod_1.z.string(),
    postbacksURL: zod_1.z.string().url().nullable(),
});
// Revenue and postback token fields are kept secret from the FE
exports.PartnerAppFE = exports.PartnerApp.pick({
    id: true,
    subSourceId: true,
    partnerName: true,
    partnerAppName: true,
    stylingConfig: true,
    featureConfig: true,
    currencyName: true,
});
exports.SystemConfig = zod_1.z.object({
    id: zod_1.z.string(),
    systemName: zod_1.z.string(),
    config: zod_1.z.any(),
    metadata: zod_1.z.any(),
});
